import styles from "./ChatBotBubble.module.css";

export default function ChatBot(props){
  return(
    <div className={styles.bubble} onClick={props.toggleOpenChatFn}>
    {!props.open ?
      <i class="fa fa-comment" aria-hidden="true"></i>:
      <i class="fa fa-close" aria-hidden="true"></i>
    }
  </div>)
}
